import { Trans } from '@lingui/macro'
import Close from '@material-ui/icons/Close'
import { deleteError } from 'actions/errors'
import { css, styles } from 'helpers'
import React from 'react'
import { connect } from 'react-redux'
import { Typography } from 'webbook-airways'

const Error = ({ error, number, errorCount, onDelete }) => (
  <div
    className={css({
      ...styles.animations.fadeInUp,
      backgroundColor: '#fff',
      padding: '10px 15px',
      marginTop: 25,
      maxWidth: 300,
      borderRadius: 3,
      boxShadow: '0 0 25px rgba(0,0,0,0.4)'
    })}
  >
    <div className={css({ display: 'flex', alignItems: 'center' })}>
      <Typography style={{ fontWeight: 700, flex: 1 }}>
        <Trans>Message</Trans>
      </Typography>
      <Close onClick={onDelete} style={{ color: '#ccc', cursor: 'pointer' }} />
    </div>
    <Typography>{error.endpoint}</Typography>

    <div
      className={css({
        display: 'flex',
        alignItems: 'flex-end',
        marginTop: 15
      })}
    >
      <div className={css({ flex: 1 })}>
        <Typography style={{ fontWeight: 700 }}>
          <Trans>Experiencing problems?</Trans>
        </Typography>
        <Typography>
          <Trans>1. Restart your browser and try again</Trans>
        </Typography>
        <Typography>
          <Trans>2. Contact our support</Trans>
        </Typography>
      </div>

      <Typography
        variant="caption"
        style={{ fontWeight: 700, marginLeft: 10, color: '#bbb' }}
      >
        {number}/{errorCount}
      </Typography>
    </div>
  </div>
)

class Errors extends React.Component {
  render() {
    const { errors } = this.props
    const activeErrors = errors.filter(error => !error.closed)

    if (activeErrors.length === 0) {
      return null
    }
    return (
      <div
        className={css({
          position: 'absolute',
          zIndex: 2000,
          bottom: 25,
          right: 25
        })}
      >
        {activeErrors.map((error, index) => (
          <Error
            key={error.id}
            error={error}
            number={index + 1}
            errorCount={activeErrors.length}
            onDelete={() => this.props.deleteError(error.id)}
          />
        ))}
      </div>
    )
  }
}

const mapStateToProps = ({ errors }) => ({ errors })
export default connect(
  mapStateToProps,
  { deleteError }
)(Errors)
